// extracted by mini-css-extract-plugin
export var lg = "_e3-7";
export var md = "_e3-6";
export var placeholderContainer = "_e3-1";
export var placeholderIcon = "_e3-2";
export var productImage = "_e3-0";
export var sm = "_e3-5";
export var xl = "_e3-8";
export var xs = "_e3-4";
export var xxs = "_e3-3";